import { useCallback, useState } from "react";
import { Button } from "components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "components/ui/dialog";
import {
  ACKNOWLEDGEMENT_COPY,
  readAcknowledgeSession,
  writeAcknowledgeSession,
} from "lib/acknowledgement";

export function AcknowledgementModal() {
  const [open, setOpen] = useState(() =>
    typeof window === "undefined" ? false : !readAcknowledgeSession()
  );

  const handleAcknowledge = useCallback(() => {
    writeAcknowledgeSession();
    setOpen(false);
  }, []);

  return (
    <Dialog
      open={open}
      onOpenChange={(next) => {
        if (next) setOpen(true);
      }}
    >
      <DialogContent
        showCloseButton={false}
        className="sm:max-w-2xl"
        onEscapeKeyDown={(e) => e.preventDefault()}
        onInteractOutside={(e) => e.preventDefault()}
      >
        <DialogHeader>
          <DialogTitle>{ACKNOWLEDGEMENT_COPY.title}</DialogTitle>
        </DialogHeader>

        <div className="max-h-[60vh] overflow-auto whitespace-pre-wrap rounded-md border bg-muted/20 p-4 text-sm leading-relaxed">
          {ACKNOWLEDGEMENT_COPY.text}
        </div>

        <DialogFooter className="sm:justify-end">
          <Button type="button" onClick={handleAcknowledge}>
            {ACKNOWLEDGEMENT_COPY.buttonText}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
